var exports = {
  "Nr": "StreamSpectatorsPopout.module__card___ZVFvcj",
  "wx": "StreamSpectatorsPopout.module__header___ZVFvcj",
  "p_": "StreamSpectatorsPopout.module__list___ZVFvcj",
  "QC": "StreamSpectatorsPopout.module__spectatorRow___ZVFvcj",
  "zh": "StreamSpectatorsPopout.module__spectatorName___ZVFvcj",
  "e": "StreamSpectatorsPopout.module__spectatorDevice___ZVFvcj",
};

module.exports = exports;
